import { motion } from "framer-motion";
import { Building2, BadgeCheck, Briefcase } from "lucide-react";
import { SectionHead, staggerContainer, staggerItem } from "../Reveal";
import { TRAINERS } from "../../data/site";

export const Trainers = () => (
  <section id="trainers" data-testid="trainers-section" className="relative py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="Meet Your Mentors"
        title={
          <>
            Trained by Engineers Who <span className="text-gradient-orange">Do This for a Living</span>
          </>
        }
        sub="No full-time 'trainers' reading slides. Your mentor ships production infrastructure at a top MNC — and teaches you exactly how it's done there."
      />

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
      >
        {TRAINERS.map((t) => (
          <motion.article
            key={t.id}
            variants={staggerItem}
            data-testid={`trainer-card-${t.id}`}
            className="group rounded-2xl border border-sky-500/20 bg-[#0B1226] overflow-hidden hover:border-orange-500/50 hover:-translate-y-2 hover:shadow-[0_0_35px_rgba(249,115,22,0.12)] transition-all duration-300"
          >
            <div className="relative h-64 overflow-hidden">
              <img
                src={t.image}
                alt={t.name}
                loading="lazy"
                className="w-full h-full object-cover object-top grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1226] via-transparent to-transparent" />
              <span className="absolute top-4 left-4 font-mono2 text-[10px] uppercase tracking-[0.2em] bg-[#060913]/80 backdrop-blur border border-sky-500/30 text-sky-300 rounded-full px-3 py-1">
                {t.track}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-display text-lg font-bold text-white">{t.name}</h3>
              <p className="text-sm text-orange-400 font-medium mt-0.5">{t.role}</p>
              <div className="mt-4 space-y-2 text-xs text-slate-400">
                <p className="flex items-center gap-2">
                  <Building2 className="w-3.5 h-3.5 text-sky-400 shrink-0" />
                  {t.company}
                </p>
                <p className="flex items-center gap-2">
                  <Briefcase className="w-3.5 h-3.5 text-sky-400 shrink-0" />
                  {t.experience} — {t.detail}
                </p>
                <p className="flex items-start gap-2">
                  <BadgeCheck className="w-3.5 h-3.5 text-orange-500 shrink-0 mt-0.5" />
                  {t.specialization}
                </p>
              </div>
            </div>
          </motion.article>
        ))}
      </motion.div>
    </div>
  </section>
);
